import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const updateListingCompatibilityList = createAsyncThunk('compatibility/updateListingCompatibilityList',
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await authSet(METHOD_POST, '/compatibility', formData);
      if (data?.message) {
        return rejectWithValue(data.message);
      }
      return data;
    } catch (error) {
      return rejectWithValue(error?.message);
    }
  });

export const clearUpdateListingCompatibilityList = createAction('compatibility/clearUpdateListingCompatibilityList');

export default updateListingCompatibilityList;
